import { DashboardActions } from "../action-types/dashboardActionTypes";

// Dashboard Action

export const getDefectreportByVesselList = (payload) => {
  return {
    type: DashboardActions.GET_DASHBOARD_DEFECT_REPORT_LIST,
    payload,
  };
};

export const setDefectreportByVesselList = (payload) => {
  return {
    type: DashboardActions.SET_DASHBOARD_DEFECT_REPORT_LIST,
    payload,
  };
};

export const getCompletedChecklistCountList = (payload) => {
  return {
    type: DashboardActions.GET_COMPLETE_CHECK_LIST_COUNT_LIST,
    payload,
  };
};

export const setCompletedChecklistCountList = (payload) => {
  return {
    type: DashboardActions.SET_COMPLETE_CHECK_LIST_COUNT_LIST,
    payload,
  };
};
export const getDefectreportAllVesselList = (payload) => {
  return {
    type: DashboardActions.GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST,
    payload,
  };
};

export const setDefectreportAllVesselList = (payload) => {
  return {
    type: DashboardActions.SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_LIST,
    payload,
  };
};

export const getDefectreportAllVesselCategoryList = (payload) => {
  return {
    type: DashboardActions.GET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST,
    payload,
  };
};

export const setDefectreportAllVesselCategoryList = (payload) => {
  return {
    type: DashboardActions.SET_DASHBOARD_DEFECT_REPORT_ALL_VESSEL_CATEGORY_LIST,
    payload,
  };
};

export const getDashboardUnreadDefectList = (payload) => {
  return {
    type: DashboardActions.GET_DASHBOARD_UNREAD_DEFECT_LIST,
  };
};

export const setDashboardUnreadDefectList = (payload) => {
  return {
    type: DashboardActions.SET_DASHBOARD_UNREAD_DEFECT_LIST,
    payload,
  };
};
